import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmTool } from "@/mixins/index";
import activities from "./mixins/activities";
import { addActivityListConfig, updActivityListConfig, activityTypeList, getActivityConfigIdToName, getActivityConfigDetailToId } from "@/api/gmtool/packageCode";
export default {
  name: "configurationActivities",
  mixins: [gmTool, activities],
  data: function data() {
    var _this = this;

    var validateDate = function validateDate(rule, value, callback) {
      if (value.day === "" || value.hour === "" || value.minutes === "" || value.seconds === "") {
        callback(new Error(_this.$t('pleaseCompleteTime')));
      } else {
        callback();
      }
    };

    return {
      paramsData: {
        config_type_id: "",
        file: "",
        config_id: "",
        config: "",
        // start_day: {
        //   day: "",
        //   hour: "",
        //   minutes: "",
        //   seconds: "",
        // },
        // end_day: {
        //   day: "",
        //   hour: "",
        //   minutes: "",
        //   seconds: "",
        // },
        id: ""
      },
      paramsDataMark: {},
      ConfigNameList: [],
      ConfigActList: [],
      TypeList: [],
      isediting: false,
      //是否编辑
      rules: {
        config_type_id: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        file: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        config_id: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        start_day: [{
          required: true,
          validator: validateDate,
          trigger: "blur"
        }],
        end_day: [{
          required: true,
          validator: validateDate,
          trigger: "blur"
        }],
        config: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }]
      },
      reqLoading: false
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this2.paramsDataMark = JSON.parse(JSON.stringify(_this2.paramsData));

              _this2.domShow();

              _this2.$bus.$off("editingDi");

              _this2.$bus.$on("editingDi", /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
                  var data, i;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this2.$refs.ruleForm && _this2.$refs.ruleForm.clearValidate();
                          data = JSON.parse(JSON.stringify(row));
                          data.config = "";

                          for (i in _this2.paramsData) {
                            _this2.paramsData[i] = data[i];
                          }

                          _context2.next = 6;
                          return _this2.configTypeChange(false);

                        case 6:
                          _context2.next = 8;
                          return _this2.nameChange(false);

                        case 8:
                          _this2.idChange(true);

                        case 9:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());

              _this2.$bus.$off("nameUpd");

              _this2.$bus.$on("nameUpd", /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(typeId) {
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(typeId && typeId == _this2.paramsData.config_type_id)) {
                            _context3.next = 4;
                            break;
                          }

                          _context3.next = 3;
                          return _this2.getAcType();

                        case 3:
                          _this2.configTypeChange(true);

                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  methods: {
    // 组件展示时触发
    domShow: function domShow() {
      this.getAcType();
    },
    configTypeChange: function configTypeChange(isClear) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (isClear) {
          _this3.paramsData.file = "";
          _this3.paramsData.config_id = "";
          _this3.paramsData.config = "";
        }

        _this3.ConfigNameList = [];
        _this3.ConfigActList = [];

        if (_this3.paramsData.config_type_id) {
          var data = _this3.TypeList.find(function (i) {
            return i.id == _this3.paramsData.config_type_id;
          });

          _this3.ConfigNameList = data.file ? data.file.split(",") : []; // if(this.ConfigNameList.findIndex(i=>i == this.paramsData.file) == -1){
          //   this.paramsData.file = ''
          //   this.paramsData.config_id = ''
          //   this.paramsData.config = ''
          // }
        }

        resolve();
      });
    },
    // 获取活动ID
    nameChange: function nameChange(isClear) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.isediting = false;
        _this4.ConfigActList = [];

        if (isClear) {
          _this4.paramsData.config = "";
          _this4.paramsData.config_id = "";
        }

        if (_this4.paramsData.file) {
          getActivityConfigIdToName({
            file: _this4.paramsData.file
          }).then(function (res) {
            if (res.status == 200) {
              _this4.ConfigActList = res.data;
            }
          }).finally(function () {
            resolve();
          });
        }
      });
    },
    // 判断活动详情是否使用
    Judgment: function Judgment() {
      var _this5 = this;

      if (this.paramsData.config_id) {
        configIdIsExist({
          config_id: this.paramsData.config_id
        }).then(function (res) {
          if (res.status == 200) {
            if (res.data) {
              _this5.$confirm(_this5.$t('configIdExistsConfirm'), _this5.$t('tip'), {
                confirmButtonText: _this5.$t('confirm'),
                cancelButtonText: _this5.$t('cancel'),
                type: "warning"
              }).then(function () {
                _this5.idChange(true);
              }).catch(function () {
                _this5.paramsData.config_id = "";
              });
            } else {
              _this5.idChange(true);
            }
          }
        });
      }
    },
    // 获取活动详情
    idChange: function idChange(isClear) {
      var _this6 = this;

      this.isediting = false;

      if (isClear) {
        this.paramsData.config = ""; // this.paramsData.start_day = {...this.paramsDataMark.start_day}
        // this.paramsData.end_day = {...this.paramsDataMark.end_day}
        // is_parse 是否解析 1 是 2 否

        getActivityConfigDetailToId({
          file: this.paramsData.file,
          config_id: this.paramsData.config_id,
          is_parse: 2
        }).then(function (res) {
          if (res.status == 200) {
            // this.paramsData.config = JSON.stringify(res.data.config, null, 2);
            _this6.paramsData.config = res.data.config;
          }
        });
      }
    },
    // 获取活动类型
    getAcType: function getAcType() {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        activityTypeList().then(function (res) {
          if (res.status == 200) {
            _this7.TypeList = res.data;

            if (_this7.paramsData.config_type_id && res.data.findIndex(function (i) {
              return i.id == _this7.paramsData.config_type_id;
            }) == -1) {
              _this7.claerData();
            }
          }
        }).finally(function () {
          resolve();
        });
      });
    },
    claerData: function claerData() {
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
      this.paramsData = _objectSpread({}, this.paramsDataMark);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this8 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this8.$confirm(_this8.$t('confirmSave'), _this8.$t('tip'), {
            confirmButtonText: _this8.$t('confirm'),
            cancelButtonText: _this8.$t('cancel'),
            type: "warning"
          }).then(function () {
            _this8.reqLoading = true;
            var data = JSON.parse(JSON.stringify(_this8.paramsData)); // let config = JSON.parse(data.config)
            // config.startTime = [this.paramsData.start_day.day,this.paramsData.start_day.hour,this.paramsData.start_day.minutes,this.paramsData.start_day.seconds,]
            // config.stopTime = [this.paramsData.end_day.day,this.paramsData.end_day.hour,this.paramsData.end_day.minutes,this.paramsData.end_day.seconds,]
            // data.config = JSON.stringify(config)

            data.page_size = "";
            var reqFn = data.id ? updActivityListConfig : addActivityListConfig;

            if (!data.id) {
              _this8.lodclickOperationLog("create-activity", _this8.$t('addActivityLog'));
            }

            reqFn(data).then(function (res) {
              if (res.status == 200) {
                _this8.$message({
                  message: _this8.$t('operationSuccess'),
                  type: "success"
                });

                _this8.claerData();

                if (data.id) {
                  _this8.$bus.$emit("DiList");
                }
              }
            }).finally(function () {
              _this8.reqLoading = false;
            });
          });
        }
      });
    }
  }
};